module.exports = __webpack_public_path__ + "img/step4.055a43df.png";